export const HOME = "HOME";
export const LIST = "LIST";
export const ADD = "ADD";